import { render, staticRenderFns } from "./DialogId8.vue?vue&type=template&id=2fc610a4&scoped=true&"
import script from "./DialogId8.vue?vue&type=script&lang=js&"
export * from "./DialogId8.vue?vue&type=script&lang=js&"
import style0 from "./DialogId8.vue?vue&type=style&index=0&id=2fc610a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc610a4",
  null
  
)

export default component.exports